module.exports = __webpack_public_path__ + "static/media/open-tab.59ef2299.png";